var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.modalShow
      ? _c("div", { staticClass: "h-vertical-align-container" }, [
          _c("div", {
            staticClass: "modal__close",
            on: {
              click: function($event) {
                _vm.overlay()
              }
            }
          }),
          _c("div", {
            staticClass: "modal__overlay",
            on: {
              click: function($event) {
                _vm.overlay()
              }
            }
          }),
          _c("div", { staticClass: "videoModal__wrapper" }, [
            _c(
              "div",
              {
                staticClass: "fluid__video",
                attrs: { id: "fluid__video--tutorial" },
                domProps: { innerHTML: _vm._s(_vm.ytVideo) }
              },
              [_vm._v(_vm._s(_vm.ytVideo))]
            )
          ])
        ])
      : _vm._e(),
    _vm._m(0),
    _c(
      "section",
      {
        directives: [
          {
            name: "scroll",
            rawName: "v-scroll",
            value: _vm.handleScroll,
            expression: "handleScroll"
          }
        ]
      },
      [
        _c("div", { staticClass: "learningLab__content" }, [
          _c("aside", { staticClass: "learningLab__content--menu" }, [
            _c("ul", { ref: "tutorialMenu" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "menu--active",
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#gettingstarted")
                      }
                    }
                  },
                  [_vm._v("Getting Started")]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#cinemagraphpro")
                      }
                    }
                  },
                  [_vm._v(" Cinemagraph Pro for macOS Tutorials")]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#cinemagraphproios")
                      }
                    }
                  },
                  [_vm._v("Cinemagraph Pro for iOS Tutorials")]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#persecond")
                      }
                    }
                  },
                  [_vm._v("Persecond for macOS Tutorials")]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#sharingcinemagraphs")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Sharing Cinemagraphs Across Social Media, Web and Presentations"
                    )
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#facebookprofilevideos")
                      }
                    }
                  },
                  [_vm._v("Facebook Profile Videos")]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#flixelcommunity")
                      }
                    }
                  },
                  [_vm._v("Flixel Community")]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#learnaboutflixel")
                      }
                    }
                  },
                  [_vm._v("Learn About Flixel")]
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "learningLab__content--videos" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.videoOptions,
                    expression: "videoOptions"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.videoOptions = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      _vm.scrollTo(_vm.videoOptions)
                    }
                  ]
                }
              },
              [
                _c(
                  "option",
                  {
                    attrs: {
                      value: "",
                      selected: "selected",
                      disabled: "disabled"
                    }
                  },
                  [_vm._v("Jump to Category")]
                ),
                _c("option", { attrs: { value: "#gettingstarted" } }, [
                  _vm._v("Getting Started")
                ]),
                _c("option", { attrs: { value: "#cinemagraphpro" } }, [
                  _vm._v("Cinemagraph Pro for macOS Tutorials")
                ]),
                _c("option", { attrs: { value: "#cinemagraphproios" } }, [
                  _vm._v("Cinemagraph Pro for iOS Tutorials")
                ]),
                _c("option", { attrs: { value: "#persecond" } }, [
                  _vm._v("Persecond for macOS Tutorials")
                ]),
                _c("option", { attrs: { value: "#sharingcinemagraphs" } }, [
                  _vm._v(
                    "Sharing Cinemagraphs Across Social Media, Web and Presentations"
                  )
                ]),
                _c("option", { attrs: { value: "#facebookprofilevideos" } }, [
                  _vm._v("Facebook Profile Videos")
                ]),
                _c("option", { attrs: { value: "#flixelcommunity" } }, [
                  _vm._v("Flixel Community")
                ]),
                _c("option", { attrs: { value: "#learnaboutflixel" } }, [
                  _vm._v("Learn About Flixel")
                ])
              ]
            ),
            _c(
              "section",
              {
                ref: "gettingstarted",
                staticClass: "noBoxShadow",
                attrs: { id: "gettingstarted" }
              },
              [
                _c("h2", [_vm._v("Getting Started")]),
                _c("div", { staticClass: "learningLab__content--grid" }, [
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=ddPsIsWdoJQ"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [_vm._m(1)]
                    ),
                    _vm._m(2)
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=VTyk8dvsxD8"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [_vm._m(3)]
                    ),
                    _vm._m(4)
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=vy73FLTcv34"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [_vm._m(5)]
                    ),
                    _vm._m(6)
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=1SkkNirjTUE"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [_vm._m(7)]
                    ),
                    _vm._m(8)
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=sZKdTJhWkDw"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [_vm._m(9)]
                    ),
                    _vm._m(10)
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=ykiVH9hqxb4"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [_vm._m(11)]
                    ),
                    _vm._m(12)
                  ])
                ])
              ]
            ),
            _c(
              "section",
              {
                ref: "cinemagraphpro",
                staticClass: "noBoxShadow",
                attrs: { id: "cinemagraphpro" }
              },
              [
                _c("h2", [_vm._v("Cinemagraph Pro for macOS Tutorials")]),
                _c("div", { staticClass: "learningLab__content--grid" }, [
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=ddPsIsWdoJQ"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [_vm._m(13)]
                    ),
                    _c("h3", [
                      _vm._v(
                        "Getting Started | Create Cinemagraphs with Cinemagraph Pro for macOS"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to compose a cinemagraph, mask, create a bounce loop, use presets, export, and upload your cinemagraph using Cinemagraph Pro for macOS"
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=KvEyYh2LN1c"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/intermediatemacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/intermediatemacOS.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "Intermediate | Create Cinemagraphs with Cinemagraph Pro for macOS"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to create a product shot cinemagraph, edit liquids in motion, precise masking, repeat loops and colour adjustments."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=0eI5QcKrkZ8"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedtutorialmacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedtutorialmacOS.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "Advanced | Create Cinemagraphs with Cinemagraph Pro for macOS"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to isolate movements on subjects, create the perfect loop and customized presets in Cinemagraph Pro for macOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=8XCZahV5Em0"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/textlogomacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/textlogomacOS.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("How to Add Images & Text")]),
                    _c("p", [
                      _vm._v(
                        "Learn how to add images and text on top of your cinemagraphs in Cinemagraph Pro for macOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=Tn4Gs4XYWbQ"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedmaskingmacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedmaskingmacOS.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("How to Create a Precise Mask")]),
                    _c("p", [
                      _vm._v(
                        "Learn how to adjust the size, hardness, and opacity of the brush tool to precisely mask overlapping motion in Cinemagraph Pro for macOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=1OmghezJzBM"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/bouncemacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/bouncemacOS.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("How to Create a Perfect Bounce Loop")]),
                    _c("p", [
                      _vm._v(
                        "Learn how to shoot and create cinemagraphs with a perfect bounce loop in Cinemagraph Pro for macOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=qeUwnqevCYI"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/repeatmacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/repeatmacOS.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "How to Create a Perfect Repeat Loop and Use Crossfade"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to shoot cinemagraphs with a repeating motion and use the trim and crossfade tools to create a perfect repeat loop in Cinemagraph Pro for macOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=IRLuJ-pBQpg"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/touchupsandadjustments@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/touchupsandadjustments.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v("How to Touch Up and Import a Still Image")
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to touch up your still image using a third-party editing application and import your edited still image for your cinemagraph in Cinemagraph Pro for macOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=dcxOh2174BA"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/stillimages@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/stillimages.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "How to Create a Cinemagraph with a Floating Subject"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to capture your video and still image separately to make your subject levitate using Cinemagraph Pro for macOS."
                      )
                    ])
                  ])
                ])
              ]
            ),
            _c(
              "section",
              {
                ref: "cinemagraphproios",
                staticClass: "noBoxShadow",
                attrs: { id: "cinemagraphproios" }
              },
              [
                _c("h2", [_vm._v("Cinemagraph Pro for iOS Tutorials")]),
                _c("div", { staticClass: "learningLab__content--grid" }, [
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=VTyk8dvsxD8"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/gettingstartediOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/gettingstartediOS.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "Getting Started | Create Cinemagraphs on iPhones and iPads with Cinemagraph Pro for iOS"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to compose a cinemagraph, mask, create a bounce loop, use presets, export, and upload your cinemagraph using Cinemagraph Pro for iOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=TrKN85c64Y0"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/intermediateiOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/intermediateiOS.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "Intermediate | Create Cinemagraphs on iPhones and iPads with Cinemagraph Pro for iOS"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to create a product shot cinemagraph on iPhones, edit liquids in motion, precise masking, repeat loops, and colour adjustments with presets in Cinemagraph Pro for iOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=z5gH6L6Wb5E"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedtutorialios@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedtutorialios.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "Advanced | Create Cinemagraphs on iPhones and iPads with Cinemagraph Pro for iOS"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to isolate movements on subjects, create the perfect loop, and colour adjustments from scratch in Cinemagraph Pro for iOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=2QSZRVnLqE0"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/textlogoiOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/textlogoiOS.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("How to Add Images & Text")]),
                    _c("p", [
                      _vm._v(
                        "Learn how to add images and text on top of your cinemagraphs in Cinemagraph Pro for iOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=MbmBlMbIgaE"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedmaskingios@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedmaskingios.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "How to Precisely Mask Cinemagraphs with Overlapping Motion"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to adjust the size, hardness, and opacity of the brush tool to precisely mask overlapping motion in Cinemagraph Pro for iOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=CAAEgsqiAUw"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/bounceios@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/bounceios.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("How to Create a Perfect Bounce Loop")]),
                    _c("p", [
                      _vm._v(
                        "Learn how to shoot and create cinemagraphs with a perfect bounce loop using the trim tool in Cinemagraph Pro for iOS."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=kA1VatH6_rk"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/repeatiOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/repeatiOS.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "How to Create a Perfect Repeat Loop and Crossfade"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to shoot cinemagraphs with a repeating motion and use the trim and crossfade tools to create a perfect repeat loop in Cinemagraph Pro for iOS."
                      )
                    ])
                  ])
                ])
              ]
            ),
            _c(
              "section",
              {
                ref: "persecond",
                staticClass: "noBoxShadow",
                attrs: { id: "persecond" }
              },
              [
                _c("h2", [_vm._v("Persecond for macOS Tutorials")]),
                _c("div", { staticClass: "learningLab__content--grid" }, [
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=vy73FLTcv34"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/persecondtutorial@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/persecondtutorial.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("Introduction to Persecond for macOS")]),
                    _c("p", [
                      _vm._v(
                        "This tutorial shows you how easy it is to make beautiful time lapses with Persecond."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=nU9iqYo1TpI"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-src":
                              "https://i1.ytimg.com/vi/nU9iqYo1TpI/maxresdefault.jpg"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v("Beautiful Time Lapses Created Using Persecond")
                    ]),
                    _c("p", [
                      _vm._v(
                        "Check out some time lapse examples created with Persecond."
                      )
                    ])
                  ])
                ])
              ]
            ),
            _c(
              "section",
              {
                ref: "sharingcinemagraphs",
                staticClass: "noBoxShadow",
                attrs: { id: "sharingcinemagraphs" }
              },
              [
                _c("h2", [
                  _vm._v(
                    "Sharing Cinemagraphs Across Social Media, Web and Presentations"
                  )
                ]),
                _c("div", { staticClass: "learningLab__content--grid" }, [
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=SE2Ol4AMYvo"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-src":
                              "https://i1.ytimg.com/vi/SE2Ol4AMYvo/maxresdefault.jpg"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "Examples of Cinemagraphs in PowerPoint and Keynote"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Transform stale presentations by using cinemagraphs in Powerpoint and Keynote."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=AFQdqjz65q4"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphfb@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphfb.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("How to Post Cinemagraphs on Facebook")]),
                    _c("p", [
                      _vm._v(
                        "Learn how to post cinemagraphs on Facebook on desktop and mobile."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=BhD3UU4ue00"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/postsnapchat@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/postsnapchat.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("How to Post Cinemagraphs on Snapchat")]),
                    _c("p", [
                      _vm._v(
                        "Learn how to post cinemagraphs on Snapchat using Memories."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=Z3mdOx7xod4"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/postinstagram@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/postinstagram.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("How to Post Cinemagraphs on Instagram")]),
                    _c("p", [
                      _vm._v(
                        "Learn how to post cinemagraphs on Instagram on mobile."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=hylc4BbxZBY"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/instagramstories@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/instagramstories.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v("How to Post Cinemagraphs on Instagram Stories")
                    ]),
                    _c("p", [
                      _vm._v(
                        "Learn how to post and style your cinemagraphs on Instagram Stories."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=wJ8U9jAJ7LA"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/posttwitter@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/posttwitter.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("How to Post Cinemagraphs on Twitter")]),
                    _c("p", [
                      _vm._v(
                        "Learn how to post cinemagraphs on Twitter on desktop and mobile."
                      )
                    ])
                  ])
                ])
              ]
            ),
            _c(
              "section",
              {
                ref: "facebookprofilevideos",
                staticClass: "noBoxShadow",
                attrs: { id: "facebookprofilevideos" }
              },
              [
                _c("h2", [_vm._v("Facebook Profile Videos")]),
                _c("div", { staticClass: "learningLab__content--grid" }, [
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=CeU1BrvB-Vg"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/fbprofilecinemagraph@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/fbprofilecinemagraph.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "Flixel Makes Facebook Cinemagraph Profile Videos With Facebook Canada"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "The Flixel team headed to Facebook Canada headquarters to create Facebook Cinemagraph Profile Videos with staff. Take a behind-the-scenes look at the visit."
                      )
                    ])
                  ])
                ])
              ]
            ),
            _c(
              "section",
              {
                ref: "flixelcommunity",
                staticClass: "noBoxShadow",
                attrs: { id: "flixelcommunity" }
              },
              [
                _c("h2", [_vm._v("Flixel Community")]),
                _c("div", { staticClass: "learningLab__content--grid" }, [
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=pT1Jn86r-C4"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/lindsayadler@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/lindsayadler.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v("Lindsay Adler Shoots a Wedding Cinemagraph")
                    ]),
                    _c("p", [
                      _vm._v(
                        "Take a look at how Lindsay Adler shoots and edits wedding cinemagraphs using Flixel Cinemagraph Pro."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=8fW8p6cbQbo"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/jonkane@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/jonkane.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v("The Creator Series: Jon Kane Houldsworth")
                    ]),
                    _c("p", [
                      _vm._v(
                        "Jon Kane Houldsworth is a New Zealand-based Flixel Wizard whose work screams visual mastermind. Learn his story in The Creator Series."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=71bPMCWlimI"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/alexandremiguel@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/alexandremiguel.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("The Creator Series: Alexandre Miguel")]),
                    _c("p", [
                      _vm._v(
                        "Meet Flixel Wizard Alexandre Miguel, the world’s most prolific cinemagraph creator with over 3,000 living photos."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=11d9y3Xs6Qk"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-src":
                              "https://img.youtube.com/vi/11d9y3Xs6Qk/mqdefault.jpg"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("The Creator Series: Thomas Brand")]),
                    _c("p", [
                      _vm._v(
                        "Meet Thomas Brand, Flixel Wizard and top cinemagraph creator from Munich, Germany."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=MNPQuRCWvgU"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/petra@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/petra.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v("Petra Švajger Shoots Fashion Cinemagraphs")
                    ]),
                    _c("p", [
                      _vm._v(
                        "Check out how pro photographer Petra Švajger shoots fashion cinemagraphs in this behind-the-scenes video."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=25e6Dokxhkg"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixelwalk@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixelwalk.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("Flixel Walk with Moment in New York")]),
                    _c("p", [
                      _vm._v(
                        "We partnered with our friends at Moment for a Flixel Walk to connect with local New York creators and shoot cinemagraphs in Brooklyn Bridge Park using iPhones."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=YtUjhdGwPFw"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-src":
                              "https://i1.ytimg.com/vi/YtUjhdGwPFw/maxresdefault.jpg"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("Flixel Walk with Joby in Las Vegas")]),
                    _c("p", [
                      _vm._v(
                        "We partnered with our friends at Joby for a Flixel Walk to shoot cinemagraphs with local creators in Las Vegas, Nevada."
                      )
                    ])
                  ])
                ])
              ]
            ),
            _c(
              "section",
              {
                ref: "learnaboutflixel",
                staticClass: "noBoxShadow",
                attrs: { id: "learnaboutflixel" }
              },
              [
                _c("h2", [_vm._v("Learn about Flixel")]),
                _c("div", { staticClass: "learningLab__content--grid" }, [
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=Yv6hGB6SFQs"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixelCTA@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixelCTA.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v("Flixel and the CTA Host #CINEMAGRAPH in New York")
                    ]),
                    _c("p", [
                      _vm._v(
                        "Take a look at #CINEMAGRAPH, a one-day event in New York City that showcased how cinemagraphs are evolving as a storytelling medium in the advertising world."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=g7y3NSMBJLY"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-src":
                              "https://i1.ytimg.com/vi/g7y3NSMBJLY/maxresdefault.jpg"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v("Flixel Creates Cinemagraphs at Techweek 2016")
                    ]),
                    _c("p", [
                      _vm._v(
                        "Go behind-the-scenes of the Flixel Booth created for Techweek 2016 using iPads and Cinemagraph Pro for iOS with Team Flixel."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=KmVVSEgMSPA"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-srcset":
                              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/holidaycinemagraphs@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/holidaycinemagraphs.png 1x"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "Flixel and Facebook Create Holiday Cinemagraphs at the Media Innovation Awards 2016"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Check out the Flixel Booth created by Team Flixel and Facebook Canada for the Media Innovation Awards hosted by Marketing Magazine."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=6dClChAFrPY"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-src":
                              "https://i1.ytimg.com/vi/6dClChAFrPY/maxresdefault.jpg"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [
                      _vm._v(
                        "First Ever Cinemagraph TV Ad by truTV and Flixel Studios"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Take a look at the first ever cinemagraph TV ad created by truTV and Flixel Studios for Pizza Hut."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid__item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/watch?v=7WQdeu5NjRE"
                        },
                        on: {
                          click: function($event) {
                            _vm.ytModal($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazy",
                          attrs: {
                            "data-src":
                              "https://i1.ytimg.com/vi/7WQdeu5NjRE/maxresdefault.jpg"
                          }
                        }),
                        _c("div", { staticClass: "playbtn" })
                      ]
                    ),
                    _c("h3", [_vm._v("What is a Cinemagraph?")]),
                    _c("p", [
                      _vm._v(
                        "Cinemagraphs are the next great storytelling medium, but how many people know what is a cinemagraph? We took to the busy streets of Toronto to see how people react to living photos."
                      )
                    ])
                  ])
                ])
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "learningLab__section" }, [
      _c("div", { staticClass: "learningLab__section--intro" }, [
        _c("h1", [_vm._v("Learning Lab Tutorials")]),
        _c("p", [
          _vm._v(
            "Ready to create cinemagraphs with Flixel Cinemagraph Pro? Want to learn more about what we do at Flixel? Check out tutorials and behind-the-scenes content created by the Flixel Team and professional Flixel Artists to get started on your cinemagraph journey."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid__item--image grid__item--imageLarge" },
      [
        _c("img", {
          staticClass: "lazy",
          attrs: {
            "data-srcset":
              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproformac@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproformac.png 1x"
          }
        }),
        _c("div", { staticClass: "playbtn" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid__item--content" }, [
      _c("h3", [_vm._v("Getting Started with Cinemagraph Pro for macOS")]),
      _c("p", [
        _vm._v(
          "Learn how to compose a cinemagraph, mask, create a bounce loop, use presets, export, and upload your cinemagraph using Cinemagraph Pro for macOS"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid__item--image grid__item--imageLarge" },
      [
        _c("img", {
          staticClass: "lazy",
          attrs: {
            "data-srcset":
              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproios@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproios.png 1x"
          }
        }),
        _c("div", { staticClass: "playbtn" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid__item--content" }, [
      _c("h3", [_vm._v("Getting Started with Cinemagraph Pro for iOS")]),
      _c("p", [
        _vm._v(
          "Learn how to compose a cinemagraph, mask, create a bounce loop, use presets, export, and upload your cinemagraph using Cinemagraph Pro for iOS."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid__item--image grid__item--imageLarge" },
      [
        _c("img", {
          staticClass: "lazy",
          attrs: {
            "data-srcset":
              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/persecond@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/persecond.png 1x"
          }
        }),
        _c("div", { staticClass: "playbtn" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid__item--content" }, [
      _c("h3", [_vm._v("Introduction to Persecond for macOS")]),
      _c("p", [
        _vm._v(
          "Learn to make beautiful time lapses videos with Persecond for macOS."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid__item--image grid__item--imageLarge" },
      [
        _c("img", {
          staticClass: "lazy",
          attrs: {
            "data-srcset":
              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixeltv@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixeltv.png 1x"
          }
        }),
        _c("div", { staticClass: "playbtn" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid__item--content" }, [
      _c("h3", [_vm._v("Introduction to Flixel TV for Apple TV")]),
      _c("p", [
        _vm._v(
          "Watch this tour of Flixel TV, the only way to experience your cinemagraphs on Apple TV."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid__item--image" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          "data-srcset":
            "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/filmingtipsmacos@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/filmingtipsmacos.png 1x"
        }
      }),
      _c("div", { staticClass: "playbtn" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid__item--content" }, [
      _c("h3", [
        _vm._v("Best Filming Tips for Creating Cinemagraphs using a DSLR")
      ]),
      _c("p", [
        _vm._v(
          "Learn the ideal camera settings for recording footage on your DSLR and how to compose a cinemagraph."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid__item--image" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          "data-srcset":
            "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/filmingtipsforiphoneandipad@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/filmingtipsforiphoneandipad.png 1x"
        }
      }),
      _c("div", { staticClass: "playbtn" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid__item--content" }, [
      _c("h3", [
        _vm._v("Filming Tips for Creating Cinemagraphs on iPhone or iPad")
      ]),
      _c("p", [
        _vm._v(
          "Learn the ideal camera settings for recording footage on your iOS device and how to compose a cinemagraph. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid__item--image grid__item--imageLarge" },
      [
        _c("img", {
          staticClass: "lazy",
          attrs: {
            "data-srcset":
              "https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproformac@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproformac.png 1x"
          }
        }),
        _c("div", { staticClass: "playbtn" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-996ed4ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-996ed4ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tutorials.vue
// module id = null
// module chunks = 